import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/TruckDrivers';
import { useAuthValidation } from '../../utils/hooks';

const TruckDriversPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default TruckDriversPage;
